
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'KnowledgeDeleteConfirmModal',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    /** Tab-specific noun, e.g. "suppression" / "enforcement" / "context entry". */
    entityLabel: {
      type: String,
      default: 'entry'
    }
  },
  methods: {
    close(): void {
      this.$emit('close')
    },
    confirm(): void {
      this.$emit('delete')
    }
  }
})
